import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.458 10.833a3.542 3.542 0 1 1 7.084 0V12.5a3.542 3.542 0 0 1-7.084 0v-1.667ZM10 7.5v8.333M7.292 5.32c0-.752.61-1.362 1.36-1.362h2.695c.752 0 1.361.61 1.361 1.361 0 .86-.696 1.556-1.555 1.556H8.847a1.555 1.555 0 0 1-1.555-1.556ZM6.25 12.292l-1.195.434a1.667 1.667 0 0 0-1.097 1.566v1.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M6.667 9.167 4.835 8.18a1.667 1.667 0 0 1-.877-1.467V4.792m9.792 7.5 1.195.434c.658.24 1.097.865 1.097 1.566v1.75m-2.709-6.875 1.832-.987c.54-.29.877-.854.877-1.467V4.792" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);